import { FileIcon, getIconForFile } from 'owa-file-icon';
import { trace } from 'owa-trace';

const TEXT_DIRECTORY_MIME_TYPE = 'text/directory';
export function getFileIcon(fileName: string, shouldBeautify: boolean, mimeType: string): string {
    if (fileName && shouldBeautify) {
        const fileIcon: FileIcon = getIconForFile(
            fileName,
            mimeType === TEXT_DIRECTORY_MIME_TYPE,
            mimeType
        );

        if (!fileIcon.cdn) {
            trace.error(`Failed to get cdn fileicon for ${fileName}`);
            return '';
        }

        return fileIcon.cdn;
    }

    return '';
}
